(function () {
    'use strict';

    angular
        .module('core.services')
        .service('AuthenticationService', AuthenticationService)

    /** @ngInject */
    function AuthenticationService($http, $q, $state, $location, $rootScope, $httpParamSerializerJQLike, MeService, ROUTES, LOCAL_STORAGE_ITEMS) {
        let userData;
        let userUnits = [];
        let selectedUserData;
        let selectedUserUnit;
        let modules = [];

        const AuthenticationService = {
            // Helpers
            passwordValidator: passwordValidator,

            // Getters
            getUserData: getUserData,
            getUserId: getUserId,
            getModules: getModules,
            getSelectedUnit: getSelectedUnit,
            getSelectedData: getSelectedData,
            getUnits: getUnits,

            // Methods
            login: login,
            logout: logout,
            isLogged: isLogged,
            handleSystemLoad: handleSystemLoad,
            canAccess: canAccess,
            setUnit: setUnit,
            configureUserPermissions: configureUserPermissions,
            getUnitDataByAccessLevelAndModuleId: getUnitDataByAccessLevelAndModuleId
        }

        return AuthenticationService;

        // Helpers
        function passwordValidator(password) {
            if (!password)
                return false;

            if (password.length < 8)
                return 'A senha deve conter ao menos 8 caracteres';

            if (!password.match(/[A-Z]/))
                return 'A senha deve conter ao menos um caracter maiúsculo';

            if (!password.match(/[0-9]/))
                return 'A senha deve conter ao menos um caracter numérico';

            return true;
        }

        // Getters
        function getUserData() {
            return {
                Id: userData.Id,
                Name: userData.Name,
                IsInOpeningProcess: selectedUserData.InOpeningProcess,
                Person_Image: userData.Person_Image,
                AccessLevel: !selectedUserData.InOpeningProcess ? selectedUserData.AccessLevel : { Description: 'Franqueado Loja' },
                Responsibility: !selectedUserData.InOpeningProcess ? selectedUserData.Responsibility : { Description: 'Franqueado' },
                EconomicGroup: !selectedUserData.InOpeningProcess ? (
                    selectedUserData.Unit && selectedUserData.Unit.EconomicGroup ? selectedUserData.Unit.EconomicGroup : null
                ) : null,
                ClusterPerformance: !selectedUserData.InOpeningProcess ? (
                    selectedUserData.Unit && selectedUserData.Unit.EconomicGroup ? selectedUserData.Unit.EconomicGroup.ClusterPerformance : null
                ) : null,
            }
        }

        function getUserId() {
            return userData.Id;
        }

        function getModules() {
            return modules;
        }

        function getSelectedUnit() {
            return selectedUserUnit;
        }

        function getSelectedData() {
            return selectedUserData;
        }

        function getUnits() {
            return userUnits;
        }

        // Methods
        function login(loginData) {
            return $http.post(`${ROUTES.API}/authorization`, $httpParamSerializerJQLike(loginData), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(response => {
                if (response != null && response != undefined)
                    return response.data;

                return response;
            });
        }

        function logout() {
            localStorage.removeItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);
            localStorage.removeItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_REFRESH);
            localStorage.removeItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_EXPIRATION);
            localStorage.removeItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_OWNER);
            localStorage.removeItem(LOCAL_STORAGE_ITEMS.SELECTED_UNIT);
            localStorage.removeItem(LOCAL_STORAGE_ITEMS.APPLICATION_AUTH);
            localStorage.removeItem(LOCAL_STORAGE_ITEMS.APPLICATION_AUTH_EXPIRATION);

            $state.go('app-auth.login');
        }

        function isLogged() {
            const accessToken = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);
            const tokenExpiration = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_EXPIRATION);

            return accessToken && moment().diff(tokenExpiration, 'hours') < 12;
        }

        function handleSystemLoad() {
            let defer = $q.defer();
            const accessToken = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);

            if (accessToken) {
                MeService
                    .getMe(accessToken)
                    .then(success => {
                        localStorage.setItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_OWNER, success.Id);

                        prepareUserData(success, defer);

                        $rootScope.hideLoading = true;

                        defer.resolve(success);
                    }, error => {
                        $rootScope.hideLoading = true;

                        defer.reject(error);
                    })
            } else {
                defer.reject({
                    error: 'User token not available from localStorage'
                });
            }

            return defer.promise;
        }

        function canAccess(transitionTo) {
            let canUserAccess = false;

            if (!selectedUserData) return false;

            if (transitionTo.url == '/' || (!transitionTo.isRestricted && !transitionTo.moduleId)) return true;

            if (transitionTo.moduleId) {
                let foundModule = modules.find(module => module.Id == transitionTo.moduleId);

                if (foundModule && (foundModule.IsGet || foundModule.IsPost || foundModule.IsPut || foundModule.IsDelete))
                    canUserAccess = true;
            }

            return canUserAccess;
        }

        function setUnit(unitId, defer) {
            if (!defer)
                defer = $q.defer();

            let state = $state.current;

            let data = userData.Person_Unit.find((x) => {
                return x.UnitId == unitId;
            });

            if (data) {
                localStorage.setItem(LOCAL_STORAGE_ITEMS.SELECTED_UNIT, data.UnitId);

                modules = getUserSelectedDataModules(data);

                selectedUserData = data;
                selectedUserUnit = data.Unit;

                if (!canAccess(state)) {
                    defer.reject({
                        error: 'User is not allowed',
                        redirTo: 'app.not-authorized'
                    });
                } else if (canAccess(state) && $location.path().indexOf('not-authorized') > 0) {
                    defer.reject({
                        error: 'User is allowed, wrong route',
                        redirTo: 'app.home'
                    });
                } else
                    defer.resolve(1);

                configureUserPermissions();
            } else
                defer.reject('Error on recovering user local data');

            return defer.promise;
        }

        function configureUserPermissions(state) {
            const currentState = state || $state.current;
            const permission = getUserPermissionsForModule(selectedUserData, currentState.moduleId);

            if (currentState.url == '' || !currentState.moduleId) {
                $rootScope.canUserView = true;
                $rootScope.canUserCreate = true;
                $rootScope.canUserEdit = true;
                $rootScope.canUserDelete = true;

                return;
            }

            if (!permission) {
                $rootScope.canUserView = false;
                $rootScope.canUserCreate = true;
                $rootScope.canUserEdit = false;
                $rootScope.canUserDelete = false;

                return;
            }

            $rootScope.canUserView = permission.IsGet;
            $rootScope.canUserCreate = permission.IsPost;
            $rootScope.canUserEdit = permission.IsPut;
            $rootScope.canUserDelete = permission.IsDelete;
        }

        function getUnitDataByAccessLevelAndModuleId(accessLevelId, moduleId) {
            const filteredPersonUnit = userData.Person_Unit.filter(personUnit => {
                if (personUnit.AccessLevelId == accessLevelId) {
                    const personUnitPermissions = getUserPermissionsForModule(personUnit, moduleId);

                    // If user has permission on the unit and has permission to post or put on the informed module
                    if (personUnitPermissions && (personUnitPermissions.IsPost || personUnitPermissions.IsPut)) {
                        return personUnit;
                    }
                }
            });

            return filteredPersonUnit;
        }

        // Internal
        function prepareUserData(data, defer) {
            userUnits = [];

            let allowedUnitId;
            let selectedUnitId = parseInt(localStorage.getItem(LOCAL_STORAGE_ITEMS.SELECTED_UNIT));

            if (selectedUnitId)
                allowedUnitId = selectedUnitId;

            for (let i = 0; i < data.Person_Unit.length; i++) {
                const user = data.Person_Unit[i];

                if (user.Unit)
                    userUnits.push(user.Unit);
            }

            userData = data;

            //If we don't have user data or user units go to not authorized
            if (userData && userData.IsInOpeningProcess && !userUnits.length) {
                defer.reject({
                    error: 'User is in opening process',
                    redirTo: 'app.opening-process'
                });

                return defer.promise;
            }

            //If we don't have user data or user units go to not authorized
            if (!userData || !userUnits.length) {
                defer.reject({
                    error: 'User doens\'t have data or units',
                    redirTo: 'app.not-authorized'
                });

                return defer.promise;
            }

            let allowedData = userUnits.find(x => (x.Id == allowedUnitId));

            if (!allowedData)
                allowedUnitId = userUnits[0].Id;

            setUnit(allowedUnitId, defer);
        }

        function getUserSelectedDataModules(data) {
            let personPermissions = [];
            let availableModules = [];

            const customPersonPermissions = data.ApiController_Person_Unit;
            const accessLevelPersonPermissions = data.AccessLevel.ApiController_AccessLevel;

            for (let index = 0; index < accessLevelPersonPermissions.length; index++) {
                const accessLevelPermission = accessLevelPersonPermissions[index];

                const foundCustomPermission = customPersonPermissions.find(perm => (perm.ApiControllerId == accessLevelPermission.ApiControllerId));

                if (foundCustomPermission) {
                    accessLevelPermission.IsGet = foundCustomPermission.IsGet;
                    accessLevelPermission.IsPost = foundCustomPermission.IsPost;
                    accessLevelPermission.IsPut = foundCustomPermission.IsPut;
                    accessLevelPermission.IsDelete = foundCustomPermission.IsDelete;
                }

                personPermissions.push(accessLevelPermission);
            }

            for (let indexP = 0; indexP < personPermissions.length; indexP++) {
                const permission = personPermissions[indexP];

                for (let indexM = 0; indexM < permission.ApiController.Module.length; indexM++) {
                    const module = permission.ApiController.Module[indexM];

                    module.IsGet = permission.IsGet;
                    module.IsPost = permission.IsPost;
                    module.IsPut = permission.IsPut;
                    module.IsDelete = permission.IsDelete;

                    if (!module.IsGet) continue;

                    if (!data.Unit.HeadUnitId && module.IsFranchiser && !module.ParentModuleId) {
                        availableModules.push(module);
                    } else if (data.Unit.HeadUnitId && module.IsFranchisee && !module.ParentModuleId) {
                        availableModules.push(module);
                    }
                }
            }

            return availableModules;
        }

        function getUserPermissionsForModule(searchData, moduleId) {
            let personPermissions = [];
            let availablePermission;

            if (searchData.ApiController_Person_Unit.length) {
                personPermissions = searchData.ApiController_Person_Unit;
            } else {
                personPermissions = searchData.AccessLevel.ApiController_AccessLevel;
            }

            for (let indexP = 0; indexP < personPermissions.length; indexP++) {
                const permission = personPermissions[indexP];

                for (let indexM = 0; indexM < permission.ApiController.Module.length; indexM++) {
                    const module = permission.ApiController.Module[indexM];

                    if (!selectedUserData.Unit.HeadUnitId && module.IsFranchiser && moduleId == module.Id) {
                        availablePermission = permission;
                    } else if (selectedUserData.Unit.HeadUnitId && module.IsFranchisee && moduleId == module.Id) {
                        availablePermission = permission;
                    }
                }
            }

            return availablePermission;
        }
    }
}());